// extracted by mini-css-extract-plugin
module.exports = {"info-box":"InfoBox_info-box__3myNj","active":"InfoBox_active__spzj4","lightbulb":"InfoBox_lightbulb__17tMs","point":"InfoBox_point__2Qhfs"};